import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InstructionsPreviewDialogComponent } from './instructions-preview-dialog.component';
import { CommonModule } from '@angular/common';
import { RichInstructionsModule } from '../../rich-instructions/rich-instructions.module';
import { A11yModule } from '@angular/cdk/a11y';
import { GoDialogContentDirective } from '@go-modules/directives/go-dialog-content/go-dialog-content.directive';
@NgModule({
	imports: [
		TranslateModule,
		CommonModule,
		RichInstructionsModule,
		A11yModule,
		GoDialogContentDirective
	],
	declarations: [
		InstructionsPreviewDialogComponent
	],
	exports: [
		InstructionsPreviewDialogComponent
	]
})
export class InstructionsPreviewDialogModule {}
